import instance from './testing.instance';

export const getDevicesList = () => instance.get(`/client/plan/devices`);

export const changeDeviceName = (llave,body) => instance.put(`client/plan/device/${llave}/set-device-name`,body);


export const changeDeviceState = (llave,body) => instance.put(`client/plan/device/${llave}/set-device-active`,body);

export const deleteDevice = (llave) => instance.delete(`/client/plan/device/${llave}/delete-device/`);

export const deleteDeviceData = (llave) => instance.delete(`/client/plan/device/${llave}/delete-data/`);

export const getDeviceStatus = (deviceKey) => instance.get(`/devices/${deviceKey}/get-status/`);




